import(/* webpackMode: "eager" */ "/root/instacks_ui/src/app/site/[subdomain]/page.tsx");
